import type { ReactNode } from 'react';

export const symbol_step_over: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M402-232.12q-32-32.12-32-78T402.12-388q32.12-32 78-32T558-387.88q32 32.12 32 78T557.88-232q-32.12 32-78 32T402-232.12ZM716-550q-32-67-95.17-108.5T480-700q-85 0-151 48.5T236-525q-5 13.84-15.42 24.42Q210.17-490 196-490q-13 0-19.5-12.5T174-529q29-102 113-166.5T479-760q81 0 149 37t112 99v-106q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v210q0 12.75-8.62 21.37Q782.75-490 770-490H560q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h156Z"
		/>
	</svg>
);
